import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

export const Loading = (props: { open?: boolean, onClose?: () => void; }) => {
    return <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={props.open === undefined ? true : props.open}
        onClick={props.onClose}
    >
        <CircularProgress sx={{ width: 100, height: 100 }} color="inherit" />
    </Backdrop>;
};
